import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const LoadingOverlay = ({ isLoading, text: initialText = "Fetching jobs for you..." }) => {
  const [currentText, setCurrentText] = useState(Array.isArray(initialText) ? initialText[0] : initialText);
  const [textIndex, setTextIndex] = useState(0);

  useEffect(() => {
    if (Array.isArray(initialText) && isLoading) {
      const interval = setInterval(() => {
        setTextIndex(prevIndex => (prevIndex + 1) % initialText.length);
      }, 2000); // Change text every 2 seconds

      return () => clearInterval(interval);
    }
  }, [initialText, isLoading]);

  useEffect(() => {
    if (Array.isArray(initialText)) {
      setCurrentText(initialText[textIndex]);
    } else {
      setCurrentText(initialText);
    }
  }, [textIndex, initialText]);


  if (!isLoading) return null;

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.3 } },
  };

  const boxVariants = {
    hidden: { scale: 0.8, opacity: 0 },
    visible: { 
      scale: 1, 
      opacity: 1,
      transition: { type: 'spring', damping: 15, stiffness: 200 } 
    },
  };

  const circleVariants = {
    hidden: { scale: 0, opacity: 0 },
    visible: {
      scale: [0.5, 1.2, 0.8, 1],
      opacity: [0, 0.7, 0.5, 0],
      transition: {
        duration: 2,
        ease: "easeInOut",
        repeat: Infinity,
        repeatDelay: 0.5
      }
    }
  };

  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      exit="hidden"
      className="fixed inset-0 z-50 flex items-center justify-center"
    >
      <div className="absolute inset-0 bg-gray-900/60 backdrop-blur-lg"></div>
      <motion.div
        variants={boxVariants}
        className="relative z-10 flex flex-col items-center justify-center p-8 rounded-lg"
      >
        <div className="relative w-24 h-24 flex items-center justify-center">
          <motion.div
            variants={circleVariants}
            className="absolute w-full h-full border-4 border-blue-400 rounded-full"
          />
          <motion.div
            variants={circleVariants}
            transition={{ ...circleVariants.visible.transition, delay: 0.5 }}
            className="absolute w-full h-full border-4 border-blue-400 rounded-full"
          />
           <svg className="w-12 h-12 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </div>
        <AnimatePresence mode="wait">
          <motion.p
            key={currentText}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.5 }}
            className="text-white text-lg font-semibold mt-8 tracking-wider"
          >
            {currentText}
          </motion.p>
        </AnimatePresence>
      </motion.div>
    </motion.div>
  );
};

export default LoadingOverlay;